<div class='message-to-wrapper' [class.first]='first'>
    <div class='speech-bubble'>
        <img class='sender-logo' src='/images/chatbot/Copeia-Globe.svg' alt='Copeia-Globe.svg' />
        <div class="say-text" id="say-text-{{index}}" [innerHtml]='params.message'></div>
        <div class="info-text" *ngIf="params.info" [innerHtml]="params.info"></div>
    </div>
</div>
